import { render } from "./MdOption.vue?vue&type=template&id=b055c7fe"
import script from "./MdOption.vue?vue&type=script&lang=js"
export * from "./MdOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__